import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Snackbar from "@mui/material/Snackbar";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import MuiAlert from "@mui/material/Alert";
import InputMask from "react-input-mask";
import { isMobile } from "react-device-detect";
import { useDate } from "../../utils/Date";
import { StyledTableCell, StyledTableRow } from "../../Components/Tables";
import { cols, rows } from "./data";
import api, {
  getAgenda,
  setAgenda,
  deleteRegistro,
  selectregistrosatuais,
} from "../../services/api";
import { Link } from "react-router-dom";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function SimpleDialog(props) {
  const { onClose, open } = props;
  const [senha, setSenha] = useState(null);

  const handleClose = () => {
    onClose("");
  };

  const handleExcluir = (senha) => {
    onClose(senha);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle sx={{ textAlign: "center" }}>
        Digite sua senha para
        <br />
        excluir este registro
      </DialogTitle>
      <TextField
        type="password"
        sx={{ margin: "20px" }}
        id="senha"
        label="senha"
        variant="standard"
        onBlur={(e) => setSenha(e.target.value)}
      />

      <Button
        variant="outlined"
        color="error"
        onClick={() => {
          handleExcluir(senha);
        }}
        sx={{ margin: "20px" }}
      >
        Excluir
      </Button>
    </Dialog>
  );
}

const Home = () => {
  const [value, setValue] = useState("one");
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [regId, setRegId] = useState(null);
  const [severity, setSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [horasArr, setHorasArr] = useState([]);
  const [horasRegistradas, setHorasRegistradas] = useState([]);
  const [emOracao, setEmOracao] = useState([]);
  const [user, setUser] = useState({
    nome: null,
    tel: null,
    senha: null,
    confirmarsenha: null,
  });
  const { date, time, wish } = useDate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const checkboxCheck = (event) => {
    let hora = event.target.id;
    let checked = event.target.checked;

    if (checked) {
      if (horasArr.indexOf(hora) === -1) {
        setHorasArr([...horasArr, hora]);
      }
    } else {
      setHorasArr(horasArr.filter((h) => h !== hora));
    }
  };

  const random_hex_color_code = () => {
    let n = (Math.random() * 0xfffff * 1000000).toString(16);
    return "#" + n.slice(0, 6);
  };

  const updateUser = (event, campo) => {
    setUser((prevState) => ({
      ...prevState,
      [campo]: event.target.value,
    }));
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleCloseDialog = (senha) => {
    setOpenDialog(false);
    if (senha !== null && senha !== "") {
      deleteRegistro(regId, senha)
        .then((res) => {
          if (
            res.data.statusText !== "Senha errada ou erro ao tentar excluir!"
          ) {
            console.log(res);
            setAlertMessage(res.data.statusText);
            setSeverity("success");
            setOpen(true);
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
            setAlertMessage(res.data.statusText);
            setSeverity("error");
            setOpen(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const deleteReg = (id) => {
    setRegId(id);
    setOpenDialog(true);
  };

  const registrarHorario = () => {
    if (user.nome === null || user.nome.lenght < 2) {
      setAlertMessage("Preencha o nome corretamente");
      setSeverity("error");
      setOpen(true);
    } else if (user.tel === null || user.tel.trim().length < 14) {
      setAlertMessage("Preencha seu telefone corretamente");
      setSeverity("error");
      setOpen(true);
    } else if (user.senha === null || user.senha.length < 2) {
      setAlertMessage("Preencha sua senha corretamente");
      setSeverity("error");
      setOpen(true);
    } else if (
      user.confirmarsenha === null ||
      user.confirmarsenha !== user.senha
    ) {
      setAlertMessage("Confirmação de senha está diferente da senha");
      setSeverity("error");
      setOpen(true);
    } else if (horasArr.length === 0) {
      setAlertMessage("Selecione pelo menos um horário");
      setSeverity("error");
      setOpen(true);
    } else {
      let horariosTemp = user;
      horariosTemp.horarios = horasArr;
      setAlertMessage("enviando dados.");
      setSeverity("warning");
      setOpen(true);

      api
        .post("/inseriragenda/index.php", horariosTemp)
        .then((res) => {
          console.log(res);
          setAlertMessage(res.data.statusText);
          setSeverity("success");
          setOpen(true);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // console.log(user, horasArr);
  };

  useEffect(() => {
    // console.log(horasArr);
  }, [horasArr]);

  useEffect(() => {
    if (value === "two") {
      getAgenda()
        .then((res) => {
          //   console.log(res.data);
          setHorasRegistradas(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [value]);

  const getEmOracao = () => {
    var coeff = 1000 * 60 * 15;
    let day = new Date().getTime();
    var rounded = new Date(Math.floor(day / coeff) * coeff);
    // console.log(
    //   "round",
    //   rounded.getHours(),
    //   rounded.getMinutes() === 0
    //     ? "0" + rounded.getMinutes()
    //     : rounded.getMinutes()
    // );
    let formated = `${
      rounded.getHours() <= 9 ? "0" + rounded.getHours() : rounded.getHours()
    }:${
      rounded.getMinutes() <= 9
        ? "0" + rounded.getMinutes()
        : rounded.getMinutes()
    }`;

    rows.map((periodo, index) => {
      periodo.map((bloco, index2) => {
        bloco.map((linha, index3) => {
          Object.entries(linha).forEach((item) => {
            if (item[1].hora.replace("h", ":").substring(0, 5) === formated) {
              let idAtual = item[1].id;
              selectregistrosatuais(idAtual)
                .then((res) => {
                  let temp = [];
                  res.data.data.map((registro) => {
                    temp.push(registro.nome);
                  });
                  setEmOracao(temp);
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          });
        });
      });
    });
  };

  useEffect(() => {
    const timer2 = setInterval(() => {
      getEmOracao();
    }, 10 * 1000);
    getEmOracao();
    return () => {
      clearInterval(timer2); // Return a funtion to clear the timer so that it will stop being called on unmount
    };
  }, []);

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          aria-label="secondary tabs example"
        >
          <Tab value="one" label="Horários" />
          <Tab value="two" label="Escala" />
        </Tabs>
      </Box>
      <SimpleDialog open={openDialog} onClose={handleCloseDialog} />
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      {value === "one" ? (
        <>
          <Box id="header" sx={{ width: "100%" }}>
            {isMobile ? (
              <h1
                style={{
                  fontSize: "4rem",
                  lineHeight: "4rem",
                  textTransform: "uppercase",
                  marginTop: "0rem",
                  color: `#00ccff`,
                }}
              >
                Relógio de Oração
              </h1>
            ) : (
              <h1
                style={{
                  fontSize: "10rem",
                  lineHeight: "10rem",
                  textTransform: "uppercase",
                  marginTop: "0rem",
                  color: `#00ccff`,
                }}
              >
                Relógio de Oração
              </h1>
            )}
            <p>
              Vamos orar pelo <b>Pr Mauro</b>. A saúde dele está novamente
              debilitada, com o avanço da mielite (inflamação que afeta os
              membros superiores e mãos).
              <br />
              <br />
              Cremos em mais um milagre.
              <br />
              <br />
              Participe conosco em fé! 
              <br />
              <br />
              Para isso, convidamos a toda Igreja (diaconia, líderes de
              ministério ,intercessão , células e membros de uma forma geral)
              para iniciarmos um relógio de oração de 20 dias.
              <br />
              <br />
              <b>FUNCIONAMENTO:</b>
              <br />
              <br />O relógio de oração terá início às{" "}
              <b>00h00 de terça-feira 10/09/2024</b> e acabará as{" "}
              <b>00h00 de do dia 30/09/2024</b> (20 dias de duração).
              <br />
              <br />
              <b>Teremos a sorte mudada nesse relógio de oração!</b>
              <br />
              <br />
              Para participar,{" "}
              <b>
                cadastre-se preenchendo os campos abaixo e escolha um horário
              </b>{" "}
              para orar.
              <br />
              <br />
              Escolha preferencialmente os <b>horários que estão em branco</b>,
              amém? A duração é de <b>15 minutos para cada agendamento</b>.
              <br />
              <br />
              Para <b>verificar os horários já preenchidos</b> por outra pessoa,
              acesse a <b>sessão ESCALA no MENU do cabeçalho</b> ou{" "}
              <span
                style={{
                  cursor: "pointer",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  color: "rgb(0, 204, 255)",
                }}
                onClick={() => setValue("two")}
              >
                CLIQUE AQUI
              </span>
              .
              <br />
              <br />
            </p>
            <br />
            <br />
            <h2
              style={{
                textAlign: "center",
                fontSize: "3rem",
                lineHeight: "0rem",
                marginTop: "1rem",
                color: `#00ccff`,
              }}
            >
              {time.replace(":", "h")}
            </h2>
            <h2
              style={{
                fontSize: "1.5rem",
                lineHeight: "1.8rem",
                marginTop: "1rem",
                marginBottom: "2rem",
                whiteSpace: "pre-wrap",
                textAlign: "center",
              }}
            >
              {emOracao.length > 0
                ? `${
                    emOracao.length === 1
                      ? `
ESTÁ ORANDO AGORA: 
`
                      : `
ESTÃO ORANDO AGORA:
`
                  } ${emOracao.map((nome, index) => {
                    return `
${nome}`;
                  })}`
                : "NINGUÉM ESTÁ ORANDO NO MOMENTO."}
            </h2>
          </Box>
          <Box sx={{ width: "100%" }}>
            <h1 style={{ color: "#00ccff" }}>Preencha com seus dados</h1>
            <TextField
              required
              sx={{ margin: "0px 20px 20px 0px" }}
              color="primary"
              id="nome"
              label="Nome"
              variant="standard"
              onBlur={(e) => {
                updateUser(e, "nome");
              }}
            />
            <InputMask
              mask="(99) 99999-9999"
              disabled={false}
              maskChar=" "
              onBlur={(e) => {
                updateUser(e, "tel");
              }}
            >
              {() => (
                <TextField
                  required
                  sx={{ margin: "0px 20px 20px 0px" }}
                  id="telefone"
                  label="Telefone"
                  variant="standard"
                />
              )}
            </InputMask>
            <TextField
              required
              sx={{ margin: "0px 20px 20px 0px" }}
              id="senha"
              label="senha"
              variant="standard"
              type="password"
              onBlur={(e) => {
                updateUser(e, "senha");
              }}
            />
            <TextField
              required
              sx={{ margin: "0px 20px 20px 0px" }}
              id="confirmarsenha"
              label="confirmar senha"
              variant="standard"
              type="password"
              onBlur={(e) => {
                updateUser(e, "confirmarsenha");
              }}
            />
          </Box>
          {cols.map((col, index) => (
            <React.Fragment key={index}>
              {index === 0 ? (
                <h1 style={{ color: "#ff6600" }}>Período do Dia</h1>
              ) : (
                <h1 style={{ color: "#6600d2" }}>Período da Noite</h1>
              )}
              {col.map((co, index2) => (
                <TableContainer
                  key={index2}
                  component={Paper}
                  sx={{ marginBottom: "20px" }}
                >
                  <Table aria-label="customized table" size={"small"}>
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.um}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.dois}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.tres}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.quatro}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.cinco}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.seis}
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {rows[index][index2].map((row, index3) => (
                        <StyledTableRow key={index3}>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "0px" }}
                          >
                            <Checkbox
                              className="checkbox"
                              id={row.um.id}
                              name={row.um.hora}
                              onChange={checkboxCheck}
                            />
                            <label htmlFor={row.um.id}>{row.um.hora}</label>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "0px" }}
                          >
                            <Checkbox
                              className="checkbox"
                              id={row.dois.id}
                              name={row.dois.hora}
                              onChange={checkboxCheck}
                            />
                            <label htmlFor={row.dois.id}>{row.dois.hora}</label>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "0px" }}
                          >
                            <Checkbox
                              className="checkbox"
                              id={row.tres.id}
                              name={row.tres.hora}
                              onChange={checkboxCheck}
                            />
                            <label htmlFor={row.tres.id}>{row.tres.hora}</label>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "0px" }}
                          >
                            <Checkbox
                              className="checkbox"
                              id={row.quatro.id}
                              name={row.quatro.hora}
                              onChange={checkboxCheck}
                            />
                            <label htmlFor={row.quatro.id}>
                              {row.quatro.hora}
                            </label>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "0px" }}
                          >
                            <Checkbox
                              className="checkbox"
                              id={row.cinco.id}
                              name={row.cinco.hora}
                              onChange={checkboxCheck}
                            />
                            <label htmlFor={row.cinco.id}>
                              {row.cinco.hora}
                            </label>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "0px" }}
                          >
                            <Checkbox
                              className="checkbox"
                              id={row.seis.id}
                              name={row.seis.hora}
                              onChange={checkboxCheck}
                            />
                            <label htmlFor={row.seis.id}>{row.seis.hora}</label>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ))}
            </React.Fragment>
          ))}
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            sx={{ margin: "40px 0px 0px" }}
          >
            <Button variant="contained" onClick={registrarHorario}>
              Registrar horário
            </Button>
          </Stack>
        </>
      ) : (
        <>
          <Box id="header" sx={{ width: "100%" }}>
            <p style={{ textAlign: "center", lineHeight: "21px" }}>
              Se em algum momento você precisar{" "}
              <b style={{ color: "#ff6600" }}>cancelar</b> ou{" "}
              <b style={{ color: "#ff6600" }}>reagendar</b> seu compromisso no
              Relógio de Oração,
              <br />
              <b style={{ color: "#ff6600" }}>clique em seu nome</b>,{" "}
              <b style={{ color: "#ff6600" }}>digite sua senha cadastrada</b> e{" "}
              <b style={{ color: "#ff6600" }}>clique em excluir</b>.<br />
              Dessa forma poderemos estar inserindo outro intercessor.
              <br />
              Qualquer dúvida, entre em contato pelo e-mail{" "}
              <a
                style={{ color: "#ff6600" }}
                href="mailto:contato@bdnatibaia.com.br"
              >
                <b>contato@bdnatibaia.com.br</b>
              </a>
              <br />
            </p>
          </Box>
          {cols.map((col, index) => (
            <React.Fragment key={index}>
              {index === 0 ? (
                <h1 style={{ color: "#ff6600" }}>Período do Dia</h1>
              ) : (
                <h1 style={{ color: "#6600d2" }}>Período da Noite</h1>
              )}
              {col.map((co, index2) => (
                <TableContainer
                  key={index2}
                  component={Paper}
                  sx={{ marginBottom: "20px" }}
                >
                  <Table aria-label="customized table" size={"small"}>
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.um}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.dois}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.tres}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.quatro}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.cinco}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              index === 0
                                ? "#ff6600 !important"
                                : "#6600d2 !important",
                            padding: "0px",
                          }}
                        >
                          {co.seis}
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {rows[index][index2].map((row, index3) => (
                        <StyledTableRow key={index3}>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "10px 0px 10px" }}
                          >
                            <label>{row.um.hora}</label>
                            <Stack
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              spacing={0}
                              sx={{
                                margin: "0px 0px 0px",
                                fontSize: "10px",
                                lineHeight: "10px",
                              }}
                              id={row.um.id}
                            >
                              {horasRegistradas.map(
                                (hora, indexUm) =>
                                  hora.horaid === row.um.id && (
                                    <h3
                                      key={indexUm}
                                      style={{
                                        margin: "5px",
                                        userSelect: "none",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        deleteReg(hora.id);
                                      }}
                                    >
                                      {hora.nome}
                                    </h3>
                                  )
                              )}
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "10px 0px 10px" }}
                          >
                            <label>{row.dois.hora}</label>
                            <Stack
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              spacing={0}
                              sx={{
                                margin: "0px 0px 0px",
                                fontSize: "10px",
                                lineHeight: "10px",
                              }}
                              id={row.dois.id}
                            >
                              {horasRegistradas.map(
                                (hora, indexDois) =>
                                  hora.horaid === row.dois.id && (
                                    <h3
                                      key={indexDois}
                                      style={{
                                        margin: "5px",
                                        userSelect: "none",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        deleteReg(hora.id);
                                      }}
                                    >
                                      {hora.nome}
                                    </h3>
                                  )
                              )}
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "10px 0px 10px" }}
                          >
                            <label>{row.tres.hora}</label>
                            <Stack
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              spacing={0}
                              sx={{
                                margin: "0px 0px 0px",
                                fontSize: "10px",
                                lineHeight: "10px",
                              }}
                              id={row.tres.id}
                            >
                              {horasRegistradas.map(
                                (hora, indexTres) =>
                                  hora.horaid === row.tres.id && (
                                    <h3
                                      key={indexTres}
                                      style={{
                                        margin: "5px",
                                        userSelect: "none",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        deleteReg(hora.id);
                                      }}
                                    >
                                      {hora.nome}
                                    </h3>
                                  )
                              )}
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "10px 0px 10px" }}
                          >
                            <label>{row.quatro.hora}</label>
                            <Stack
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              spacing={0}
                              sx={{
                                margin: "0px 0px 0px",
                                fontSize: "10px",
                                lineHeight: "10px",
                              }}
                              id={row.quatro.id}
                            >
                              {horasRegistradas.map(
                                (hora, indexQuatro) =>
                                  hora.horaid === row.quatro.id && (
                                    <h3
                                      key={indexQuatro}
                                      style={{
                                        margin: "5px",
                                        userSelect: "none",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        deleteReg(hora.id);
                                      }}
                                    >
                                      {hora.nome}
                                    </h3>
                                  )
                              )}
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "10px 0px 10px" }}
                          >
                            <label>{row.cinco.hora}</label>
                            <Stack
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              spacing={0}
                              sx={{
                                margin: "0px 0px 0px",
                                fontSize: "10px",
                                lineHeight: "10px",
                              }}
                              id={row.cinco.id}
                            >
                              {horasRegistradas.map(
                                (hora, indexCinco) =>
                                  hora.horaid === row.cinco.id && (
                                    <h3
                                      key={indexCinco}
                                      style={{
                                        margin: "5px",
                                        userSelect: "none",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        deleteReg(hora.id);
                                      }}
                                    >
                                      {hora.nome}
                                    </h3>
                                  )
                              )}
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            sx={{ padding: "10px 0px 10px" }}
                          >
                            <label>{row.seis.hora}</label>
                            <Stack
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              spacing={0}
                              sx={{
                                margin: "0px 0px 0px",
                                fontSize: "10px",
                                lineHeight: "10px",
                              }}
                              id={row.seis.id}
                            >
                              {horasRegistradas.map(
                                (hora, indexSeis) =>
                                  hora.horaid === row.seis.id && (
                                    <h3
                                      key={indexSeis}
                                      style={{
                                        margin: "5px",
                                        userSelect: "none",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        deleteReg(hora.id);
                                      }}
                                    >
                                      {hora.nome}
                                    </h3>
                                  )
                              )}
                            </Stack>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ))}
            </React.Fragment>
          ))}
        </>
      )}
    </>
  );
};

export default Home;
